<template>
<div :style="styles.row">
<div :style="styles.container">
    <div :style="styles.caption">Total</div>
    <div :style="styles.amountCaption">{{ numeral(total).format('0,0.00'), }}</div>
    <div :style="styles.caption">Ppn</div>
    <div :style="styles.amountCaption">{{ numeral(ppn).format('0,0.00'), }}</div>
    <br />
    <div :style="styles.caption">Grand Total</div>
    <div :style="styles.amountCaption">{{ numeral(grandTotal).format('0,0.00'), }}</div>
</div>
</div>
</template>

<script>
export default {
  props: ['total', 'ppn', 'grandTotal'],
  data() {
    return {
      styles: {
          row: {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
          },
          container: {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
              padding: '16px',
              borderRadius: '5px',
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: '#CACCCF',
              boxShadow: `0 3px 10px rgba(0,0,0,.1), 0 3.5px 5px rgba(204,150,44,.1)`,
          },
          caption: {
              fontSize: '15px',
              color: '#000000',
          },
          amountCaption: {
              fontSize: '20px',
              color: '#25282B',
              fontWeight: 'bold',
          }
      }
    }
  },
}
</script>